// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27IIb","tabsBox":"styles_tabsBox__2XE5N","createButton":"styles_createButton__3lrdH"};